import { Box, Card, Typography, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Lottie from "lottie-react";
import WELL_DONE from '../../Utils/well-done.json';

const VerifyLeaderPopModel = ({ lead, onClose }) => {
    return (
        <Box sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1300,
            p: { xs: 1, sm: 2, md: 3 }
        }}>
            <Card sx={{
                position: 'relative',
                maxWidth: { xs: '90%', sm: '80%', md: 500 },
                width: '100%',
                textAlign: 'center',
                p: { xs: 2, sm: 3, md: 4 },
                borderRadius: '12px',
                boxShadow: '0px 10px 25px rgba(0, 0, 0, 0.2)',
                background: '#fff',
                border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
                {/* Close button */}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{

                        position: 'absolute',
                        right: { xs: 8, sm: 8 },
                        top: { xs: 8, sm: 8 },
                        color: '#000',
                        '&:hover': {
                            color: '#000',
                        }
                    }}
                >
                    <CloseIcon sx={{ fontSize: { xs: '1rem', sm: '22px' } }} />
                </IconButton>
                <Box sx={{
                    width: 150,
                    height: 150,
                    mx: 'auto',
                    mb:2
                }}>
                    <Lottie animationData={WELL_DONE} loop={true} />
                </Box>
                <Typography variant="body1" sx={{
                    mb: { xs: 2, sm: 3 },
                    color: '#000',
                    fontWeight: 400,
                    fontSize: { xs: '0.875rem', sm: '1rem' },
                    fontFamily: "Poppins",
                    lineHeight: '1.6'
                }}>
                    {lead?.title}
                </Typography>
                <Box sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(76, 175, 80, 0.2)',
                    borderRadius: '8px',
                    px: { xs: 2, sm: 3 },
                    py: { xs: 1, sm: 1.5 },
                    border: '1px solid rgba(76, 175, 80, 0.3)'
                }}>
                    <Typography variant="h6" component="div" sx={{
                        fontWeight: 600,
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                        fontFamily: "Poppins",
                        color: '#4CAF50',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        {lead?.body}
                    </Typography>
                </Box>
            </Card>
        </Box>
    );
};

export default VerifyLeaderPopModel;